import React from 'react';
import { Phone, Mail, Linkedin } from 'lucide-react';
import { siteConfig } from '../data/mock';

const TopBar = () => {
  return (
    <div style={{ backgroundColor: '#43a047' }} className="py-1.5 px-4">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-4 text-white text-sm">
          <a href={`tel:${siteConfig.phone}`} className="flex items-center gap-1.5 hover:text-green-100 transition-colors">
            <Phone size={12} />
            <span>Call Us: {siteConfig.phone}</span>
          </a>
          <span className="text-green-200">|</span>
          <a href={`mailto:${siteConfig.email}`} className="flex items-center gap-1.5 hover:text-green-100 transition-colors">
            <Mail size={12} />
            <span>{siteConfig.email}</span>
          </a>
        </div>
        <div className="flex items-center gap-2">
          <a
            href={siteConfig.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-green-100 transition-colors bg-white/20 hover:bg-white/30 rounded p-1"
          >
            <Linkedin size={13} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
